import { render, staticRenderFns } from "./OperationAssignmentsDialog.vue?vue&type=template&id=60b28e2c&scoped=true"
import script from "./OperationAssignmentsDialog.vue?vue&type=script&lang=ts"
export * from "./OperationAssignmentsDialog.vue?vue&type=script&lang=ts"
import style0 from "./OperationAssignmentsDialog.vue?vue&type=style&index=0&id=60b28e2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b28e2c",
  null
  
)

export default component.exports